import { DashboardListItemModel } from 'types/dashboard/DashboardListItemModel';
import { dateToIsoString } from 'util/utils';

/**
 * The date line shown on a dashboard card: the Version date of the last published version once the
 * item has been published (for Dynamic Forms also after depublication or deregistration), otherwise
 * the creation date. Shared by every card type so the rule lives in one place.
 */
export const getCardDateText = (item: DashboardListItemModel): string =>
  item.publishedVersionDate
    ? `Version date: ${dateToIsoString(item.publishedVersionDate)}`
    : `Created: ${dateToIsoString(item.createdAt)}`;
